import { ActivatedRouteSnapshot } from '@angular/router';
import { uploadDocumentTokenizer } from '@data-access/documents/token';
import { Submission } from '../../../submissions/next/models';

export const workspaceUploadDocumentResolver = (
  route: ActivatedRouteSnapshot,
) => {
  const _uploadDcumentStore = uploadDocumentTokenizer();
  const _submission = route.parent?.data['submission'] as Submission;
  return _uploadDcumentStore.loadDocumentTypes({
    workspaceId: _submission?.id,
  });
};
